
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type genericMiniStoreVehicleLabelRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function genericMiniStoreVehicleLabelRT(): TemplateResult<genericMiniStoreVehicleLabelRTRootProps> {
    return _createElement('div', {}, this.template === 'active' ? _createElement('div', {
        'className': 'cmTemplate_active',
        'key': '8'
    }, _createElement('h1', { 'className': 'model-selector-title' }, 'Shop For Your Vehicle')) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cmTemplate_locked',
        'key': '160'
    }, _createElement('h1', { 'className': 'model-selector-title' }, 'Shop For Your ', this.vehicleString), _createElement('div', {
        'className': 'cm_button button button--primary',
        'onClick': this.openDialog
    }, 'Change Vehicle')) : null);
}
        export const componentNames = []